import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20cultural%20content%20platform%2C%20abstract%20artistic%20composition%20with%20warm%20golden%20and%20amber%20gradient%20background%2C%20flowing%20ink%20brush%20textures%20blending%20with%20digital%20geometric%20patterns%2C%20elegant%20minimalist%20aesthetic%2C%20sophisticated%20editorial%20design%20vibe%2C%20no%20text%2C%20clean%20composition&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
        alt="国产精品一区"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-sparkling-line text-primary-300"></i>
          <span className="text-sm text-background-50/90 font-medium">精选优质国产原创内容聚合平台</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          发现中国原创精品
          <br />
          <span className="text-primary-300">感受国粹文化力量</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          汇聚海量高品质国产原创内容，严选一区精品资源，为您提供流畅、高清、稳定的在线体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yingshi"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap shadow-sm"
          >
            <i className="ri-compass-3-line mr-2"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap border border-background-50/30"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          {[
            { value: '200+', label: '原创作者' },
            { value: '5000+', label: '精品内容' },
            { value: '50万+', label: '月活跃用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs text-background-50/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}